import logoIcon from "@assets/images/Group-12652.svg";
import logoText from "@assets/images/Group-12653.svg";
import logoIconWhite from "@assets/images/Group-126521.svg";
import logoTextWhite from "@assets/images/Group-126531.svg";
import { Link } from "react-router-dom";

interface LogoProps {
  variant?: "default" | "white";
  className?: string;
}

export function Logo({ variant = "default", className = "" }: LogoProps) {
  const icon = variant === "white" ? logoIconWhite : logoIcon;
  const text = variant === "white" ? logoTextWhite : logoText;

  return (
    <Link
      to="/"
      className={`flex items-center gap-[4.4px] flex-shrink-0 ${className}`}
    >
      <img
        src={icon}
        alt="GASIS"
        className="h-[40px] w-[40px] shrink-0"
        loading="lazy"
      />
      <img
        src={text}
        alt=""
        className="h-[35px] w-[56px] shrink-0"
        loading="lazy"
      />
    </Link>
  );
}
